import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-responsive-modal';
import root from 'window-or-global';
import {connect} from 'react-redux';

import Message from '../../common/message/Message';
import participationAction from '../../../actions/ParticipationActions';
import {getCookie} from '../../../utils/Utils';

const mapStateToProps = (state) => {
    let config = state.get('config');
    config = config ? config.toJS() : {};
    return {
        configState: config,
        participationState: state.get('participation').toJS(),
        userState: state.get('user').toJS()
    };
};

const mapDispatchToProps = {
    getForm: participationAction.getForm,
    showMismatchModal: participationAction.showMismatchModal
};

@connect(mapStateToProps, mapDispatchToProps)
export default class MismatchModal extends React.Component {
    static propTypes = {
        closeModal: PropTypes.func,
        configState: PropTypes.object,
        userState: PropTypes.object,
        getForm: PropTypes.func,
        showMismatchModal: PropTypes.func,
        formToken: PropTypes.string,
        participationState: PropTypes.object
    };

    state = {
        continued: false
    };

    componentDidMount() {
        const { showMismatchModal, userState, formToken, getForm, configState } = this.props;
        if (userState.isLoggedIn) {
            let cookie = getCookie(configState.participationToken);
            if (cookie) {
                cookie = decodeURIComponent(cookie);
                cookie = JSON.parse(cookie);
                if (userState.accountInfo.id === cookie[formToken]) {
                    getForm(formToken);
                } else {
                    showMismatchModal();
                }
            } else {
                showMismatchModal();
            }
        }
    }

    onClickCancel = () => {
        const { configState } = this.props;
        const currentUrl = root.location.href;
        root.location.href = `${configState.apiContext}/back/logout?state=${currentUrl}`;
    };

    onClickContinue = () => {
        const {getForm, userState, closeModal, formToken, participationState: {invalid} } = this.props;
        if (userState.isLoggedIn) {
            if (invalid) {
                closeModal();
                return;
            }
            this.setState({continued: true});
            getForm(formToken);
        }
        closeModal();
    };

    render() {
        const {participationState: { mismatch }, userState} = this.props;
        const { continued } = this.state;
        const {accountInfo: {displayName}} = userState;

        return (
            <div>
                <Modal
                    open={mismatch && !continued}
                    styles={{closeIcon: {color: '#ababab'}}}
                    center
                    showCloseIcon={false}
                    onClose={() => {}}
                    classNames={{modal: 'enterprise-modal_subscribe-error'}}>
                    <p className="error-title">
                        <Message code="epic.esport.mismatch.title" />
                    </p>
                    <div className="gray-box">
                        <p>
                            <Message code="epic.esport.mismatch.text1" />
                        </p>
                        <p className="mismatch-modal-name">{displayName}</p>
                        <p>
                            <Message code="epic.esport.mismatch.text2" />
                        </p>
                        <p>
                            <Message code="epic.esport.mismatch.text3" args={[displayName]} />
                        </p>

                        <div className="mismatch-modal-action row">
                            <button className="btn mismatch-btn col-xs-12 col-lg-5" onClick={this.onClickCancel}>
                                <Message code="epic.esport.mismatch.switch_accounts" />
                            </button>
                            <button className="btn btn-primary col-xs-12 col-lg-5 mismatch-btn" onClick={this.onClickContinue}>
                                <Message code="epic.common.continue" />
                            </button>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}
